import ReactGA from "react-ga4";

export const initAnalytics = () => {
  ReactGA.initialize("G-4G59BB155X"); // Replace with your Measurement ID
};

export const trackPageView = (page) => {
  ReactGA.send({ hitType: "pageview", page });
};
